import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        questionPool: '='
    },
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <ul class="actions01">
                    <li>
                        <forms-settings-pool-translation ng-if="vm.QuestionService.canManageQuestionRelatedData()" form="vm.form" question-pool="vm.questionPool"></forms-settings-pool-translation>
                    </li>
                    <li>
                        <a ui-sref="authorized.forms.settings.pool.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a>
                    </li>
                </ul>
                <h1>{{ 'questionPool.Pool name' | translate }}</h1>
            </div>
            <div class="well">
                <h2>{{ 'questionPool.General data' | translate }}</h2>
                <form>
                <div class="form">
                    <forms-settings-pool-generaldata form="vm.form"></forms-settings-pool-generaldata>
                    <div class="row">
                        <span class="label">&nbsp;</span>
                        <div class="items">
                            <ul class="actions01">
                                <li ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="primary"><a class="btn main" ng-click="vm.save()">{{ 'general.Save' | translate }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                </form>
            </div>
            <div class="tablewrapper">
                <h2>{{ 'questionPool.Structure' | translate }}</h2>
                <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
                <div class="well color02" ng-if="!vm.list.loading && vm.list.items.length">
                    <table class="data01" datatable dt-options="vm.DATATABLES" >
                        <thead>
                            <tr>
                                <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'question.Name' | translate }}</a></th>
                                <th ng-class="vm.list.getSortClass('category')"><a ng-click="vm.list.sortBy('category')">{{ 'questions.Category' | translate }}</a></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="question in vm.list.items">
                            <td><a ui-sref="authorized.forms.questions.all.question({ id: question.id })">{{ question.nameWithoutHtml }}</a></td>
                                <td>{{ question.category ? question.category.name : '' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
            <ul class="actions01">
                <li class="primary"><a ng-click="vm.exportCsv()" class="btn bordered02">{{ 'questionPool.Export questions' | translate }}</a></li>
                <li ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="primary">
                    <a ng-click="vm.deleteQuestionPool(vm.questionPool.id)" class="btn negative">
                        {{ 'questionPool.Delete question pool' | translate }}
                    </a>
                </li>
                <li><a ui-sref="authorized.forms.settings.pool.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($state, $translate, $window, DATATABLES, FormFactory, ListFactory, ModalService, QuestionService, QuestionResource, QuestionPoolResource, AuthResource) {
        this.$state = $state;
        this.$translate = $translate;
        this.$window = $window;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.QuestionService = QuestionService;
        this.QuestionPoolResource = QuestionPoolResource;
        this.AuthResource = AuthResource;
        this.language = $translate.use();

        this.form = FormFactory.create(this.questionPool, model => model.$update({ id: model.id }));

        this.list = ListFactory.createWithPagination(QuestionResource.query.bind(QuestionResource));
        this.list.fetch({ questionPoolId: this.questionPool.id, expand: 'category,activeI18n' });
    }

    save () {
        this.form.save()
            .then(() => {
                this.$state.go('authorized.forms.settings.pool.list');
            });
    }

    deleteQuestionPool (id) {
        this.ModalService.confirm(
            this.$translate.instant('questionPool.Are you sure you want to delete this question pool')
            , 'large'
        ).then(() => {
            this.QuestionPoolResource.delete({ id }).$promise.then(() => {
                this.$state.go('authorized.forms.settings.pool.list');
            });
        });
    }

    exportCsv () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const qs = `questionPoolId=${this.questionPool.id}&_lang=${this.language}`;
                const url = `${SEED_CORE.ENV.API_URL}form/question/export/?tacToken=${token}&${qs}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/pool/edit/index.js